export default {
  LOAD_LIST(state, data) {
    state.listItem = data
  },
  PREPARE_TO_EDIT(state, data) {
    state.item = data
  },
}
